/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Title, Loader } from 'shared-components';
import { IncidentContainer, IncidentsGroup } from '../styles';
import Incident from '../Incident';
import ClientErrorComponent from '../../../components/ClientErrorComponent';
import { extendIncidents } from '../helper';

function PastIncidents({ pastIncidents, isLoading, isError }) {
  const twoweeksIncidents = extendIncidents(pastIncidents.filter(incident => incident.category !== 'maintenance'), 14);
  return (
    <div>
      <Title>Past Incidents</Title>
      <Card className="mb-3">
        {isLoading && <Loader />}
        {!isLoading && isError && <ClientErrorComponent data={{}} />}
        {!isLoading && !isError && (
          <IncidentsGroup>
            {twoweeksIncidents.reverse().map(incident => (
              <IncidentContainer key={incident.date}>
                <h4>
                  {new Date(incident.date).toLocaleDateString('en-US', {
                    timeZone: 'UTC',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </h4>
                {incident.incidents ? (
                  incident.incidents.reverse().map(incident => (
                    <Incident
                      key={incident.id + Math.random()}
                      incident={incident}
                    />
                  ))
                ) : (
                  <p>No incidents reported.</p>
                )}
              </IncidentContainer>
            ))}
          </IncidentsGroup>
        )}
      </Card>
    </div>
  );
}

export default PastIncidents;
